export const PADDING_HALF = 5
export const PADDING = 10
